import React, { memo } from 'react';
import { defaultBodyContentMeeting } from '../../styles';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

const ColumnText = (props: any) => {
  const renderText = (text: any) => {
    switch (text['value']) {
      case 'patientno':
        return (
          <Stack direction={'row'}>
            <Typography
              sx={{ ...defaultBodyContentMeeting }}
              component='div'
              dangerouslySetInnerHTML={{
                __html: text['label'],
              }}
            />
            {text['vip'] && (
              <span
                className={`q-icon notranslate material-icons q-mr-sm`}
                aria-hidden='true'
                role='presentation'
                style={{ color: '#FFC000' }}
              >
                grade
              </span>
            )}
          </Stack>
        );
      case 'patientname':
      case 'createfrom':
        return (
          <Typography
            sx={{ ...defaultBodyContentMeeting, fontWeight: '700 !important' }}
            component='div'
            dangerouslySetInnerHTML={{
              __html: text['label'],
            }}
          />
        );
      case 'icons':
        return (
          <Typography
            sx={{ ...defaultBodyContentMeeting}}
            component='div'
            dangerouslySetInnerHTML={{
              __html: text['label'].replace('q-badge flex inline items-center no-wrap q-badge--single-line bg-red text-white q-mr-xs', '').replace(`>!</div>`, '></div>'),
            }}
          />
        );
      default:
        return (
          <Typography
            sx={{ ...defaultBodyContentMeeting }}
            component='div'
            dangerouslySetInnerHTML={{
              __html: text['label'],
            }}
          />
        );
    }
  };

  return props.colText.map((text: any, index: number) => (
    <React.Fragment key={index}>{renderText(text)}</React.Fragment>
  ));
};

export default memo(ColumnText);
